import {
  faCheck,
  faChevronUp,
  faChevronDown
} from '@fortawesome/pro-regular-svg-icons'

import {
  faCalendarAlt,
  faCalendarExclamation
} from '@fortawesome/pro-light-svg-icons'

import { library } from '@fortawesome/fontawesome-svg-core'

export default function initiateIconLibrary(): void {
  library.add(
    faCalendarAlt,
    faCalendarExclamation,
    faCheck,
    faChevronDown,
    faChevronUp
  )
}

initiateIconLibrary()
